import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class Dashboardjs {

    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
        this.declarationCheckShow = {
            Paid: false,
            Guarantor: false,
            CEU: false
        };
        this.ceuItemCount = 0;
    }

    async addCEUClass1(e, validateFailedId, submittingId, addedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        e.preventDefault();
        await this.postAddCEU(e,
            'AddCEUClass1',
            'Certification',
            validateFailedId,
            submittingId,
            addedId,
            classElementId,
            sessionElementId,
            cycleElementId,
            resultElementId,
            modElementId,
            modRefElementId,
            selectDateId
        );

    }

    async addCEUClass2or3(e, validateFailedId, submittingId, addedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        e.preventDefault();
        await this.postAddCEU(e,
            'AddCEUClass2or3',
            'Certification',
            validateFailedId,
            submittingId,
            addedId,
            classElementId,
            sessionElementId,
            cycleElementId,
            resultElementId,
            modElementId,
            modRefElementId,
            selectDateId
        );
    }

    async editCEUClass1(e, validateFailedId, submittingId, updatedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        e.preventDefault();
        await this.putEditClass(e,
            'EditCEUClass1',
            'Certification',
            validateFailedId,
            submittingId,
            updatedId,
            classElementId,
            sessionElementId,
            cycleElementId,
            resultElementId,
            modElementId,
            modRefElementId,
            selectDateId
        );
    }

    async editCEUClass2or3(e, validateFailedId, submittingId, updatedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        e.preventDefault();
        await this.putEditClass(e,
            'EditCEUClass2or3',
            'Certification',
            validateFailedId,
            submittingId,
            updatedId,
            classElementId,
            sessionElementId,
            cycleElementId,
            resultElementId,
            modElementId,
            modRefElementId,
            selectDateId
        );
    }

    async postAddCEU(e, action, controller, validateFailedId, submittingId, addedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        var intervalKeepLoadList;
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(validateFailedId);
        that.utilsjs.showById(submittingId);
        var validate = that.ceuDateValidate(selectDateId);
        if (validate) {
            if (await that.ajaxjs.serializeAndPostForm(e.target.id, action, controller) === '201') {
                window.setTimeout(function () {
                    that.utilsjs.hideById(submittingId);
                    that.utilsjs.showById(addedId);
                    that.selectListChanged(null, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId);

                    //CUSTOM: keep call get list
                    var countItemAfterAdd = (that.ceuItemCount + 1);
                    setTimeout(function () {
                        if (countItemAfterAdd !== that.ceuKeepGetList()) {
                            intervalKeepLoadList = setInterval(function () {
                                that.selectListChanged(null, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId);

                                if (countItemAfterAdd === that.ceuKeepGetList()) {
                                    that.ceuItemCount = that.ceuKeepGetList();
                                    clearInterval(intervalKeepLoadList);
                                }
                            }, 1000);
                        } else {
                            that.ceuItemCount = that.ceuKeepGetList();
                        }
                    }, 2000);
                }, 500);
            } else {
                that.utilsjs.showById(validateFailedId);
                that.utilsjs.hideById(submittingId);
                button.disabled = false;

                clearInterval(intervalKeepLoadList);
            }
        } else {
            that.utilsjs.hideById(submittingId);
            button.disabled = false;
            that.utilsjs.showById(validateFailedId);

            clearInterval(intervalKeepLoadList);
        }
    }

    async putEditClass(e, action, controller, validateFailedId, submittingId, updatedId, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId, selectDateId) {
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(validateFailedId);
        that.utilsjs.showById(submittingId);
        var validate = that.ceuDateValidate(selectDateId);
        if (validate) {
            var data = that.getEditValueForm(e.target.id)
            if (await that.ajaxjs.serializeAndPostForm(e.target.id, action, controller) === '204') {
                window.setTimeout(function () {
                    that.utilsjs.hideById(submittingId);
                    that.utilsjs.showById(updatedId);
                    that.selectListChanged(null, classElementId, sessionElementId, cycleElementId, resultElementId, modElementId, modRefElementId);
                    that.updateValueCEU(data.data, data.id)
                }, 3000);
            } else {
                that.utilsjs.showById(validateFailedId);
                that.utilsjs.hideById(submittingId);
                button.disabled = false;
            }
        } else {
            that.utilsjs.hideById(submittingId);
            button.disabled = false;
            that.utilsjs.showById(validateFailedId);
        }
    }

    selectListChanged(e, classElementId, sessionElementId, cycleElementId, resultElementId, modRefElementId) {
        let elem = e;
        if (elem != null) elem.disabled = true;
        var classSelected = cscpjs.default.utilsjs.getSelectedValue(classElementId);
        var cycleSelected = cscpjs.default.utilsjs.getSelectedValue(cycleElementId);
        var modRef = document.getElementById(modRefElementId).value;
        var queryString = `?modRef=${modRef}&&classSelected=${classSelected}&&cycleSelected=${cycleSelected}`;
        this.ajaxjs.loadPartialActionControllerQuerystringElement('FilterCEU', 'Certification', queryString, document.getElementById(resultElementId), () => {
            cscpjs.default.dashboardjs.checkCeuIncompleted();
            this.checkIfCycleIsComplete();
            this.utilsjs.loadSafariDatePicker();
            if (elem != null) elem.disabled = false;
        });
    }

    showAddClass(e, sectionId, ddlClassAddId, modRefElementId, editsectionId) {
        let elem = e;
        elem.disabled = true;
        cscpjs.default.utilsjs.showById(sectionId);
        var selected = cscpjs.default.utilsjs.getSelectedValue(ddlClassAddId);
        var modRef = document.getElementById(modRefElementId).value;
        var queryString = `?modRef=${modRef}&&showAddClass=1&&addClassSelected=${selected}`;
        cscpjs.default.ajaxjs.loadPartialActionControllerQuerystringElement('GetAddCEU', 'Certification', queryString, document.getElementById(sectionId), () => {
            this.ceuCallback();
            window.scrollToEditClass();
            elem.disabled = false;
        });
        document.getElementById(editsectionId).innerHTML = "";
    }

    showEditClass(e, sectionId, contentId, classCategory, modRefElementId, addSectionId, languageCode = '') {
        let elem = e;
        elem.style.backgroundColor = "lightgrey";
        this.utilsjs.showById(sectionId);
        var modRef = document.getElementById(modRefElementId).value;
        var queryString = `?modRef=${modRef}&&showEditClass=1&&contentId=${contentId}&&classCategory=${classCategory}&&languageCode=${languageCode}`;
        this.ajaxjs.loadPartialActionControllerQuerystringElement('GetEditCEU', 'Certification', queryString, document.getElementById(sectionId), () => {
            this.ceuCallback();
            window.scrollToEditClass();
            elem.style.backgroundColor = "";
        });
        document.getElementById(addSectionId).innerHTML = "";
    }

    async deleteCEUClass(e, contentIdInputId, failedId, deletingId, classElementId, sessionElementId, cycleElementId, resultElementId, modRefElementId, languageCode = '') {
        var intervalKeepLoadList;
        var that = this;
        let button = e;
        var data = {
            contentId: Number(document.getElementById(contentIdInputId).value),
            languageCode: languageCode
        };
        button.disabled = true;
        that.utilsjs.showById(deletingId);

        fetch(`${window.location.protocol}//${window.location.host}/Certification/DeleteCEUClass?sdfsd`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(deleteResponse => {
                if (deleteResponse > 0) {
                    if (deleteResponse === 202) {
                        that.selectListChanged(e, classElementId, sessionElementId, cycleElementId, resultElementId, modRefElementId);

                        //CUSTOM: keep call get list
                        var countItemAfterAdd = (that.ceuItemCount - 1);
                        setTimeout(function () {
                            if (countItemAfterAdd !== that.ceuKeepGetList()) {
                                intervalKeepLoadList = setInterval(function () {
                                    that.selectListChanged(e, classElementId, sessionElementId, cycleElementId, resultElementId, modRefElementId);
                                    if (countItemAfterAdd === that.ceuKeepGetList()) {
                                        that.ceuItemCount = that.ceuKeepGetList();
                                        clearInterval(intervalKeepLoadList);
                                    }
                                }, 1000);
                            } else {
                                that.ceuItemCount = that.ceuKeepGetList();
                            }
                        }, 2000);
                    } else {
                        clearInterval(intervalKeepLoadList);
                        if (deleteResponse === 500 || deleteResponse === 422) {
                            that.utilsjs.showById(failedId);
                            button.disabled = false;
                        }
                    }
                } else {
                    clearInterval(intervalKeepLoadList);
                }
            });
    }

    closeSection(sectionId, imageId) {
        let that = this;
        that.utilsjs.addClass(sectionId, 'hide-on-mobile');
        that.utilsjs.removeClass(sectionId, 'show-on-mobile');
        that.utilsjs.changeImgSrc(imageId, '/Content/images/icons/Down.svg');
        let call = `cscpjs.default.dashboardjs.openSection('${sectionId}', '${imageId}')`;
        that.utilsjs.changeOnclick(imageId, call);
    }

    openSection(sectionId, imageId) {
        let that = this;
        that.utilsjs.addClass(sectionId, 'show-on-mobile');
        that.utilsjs.removeClass(sectionId, 'hide-on-mobile');
        that.utilsjs.changeImgSrc(imageId, '/Content/images/icons/Up.svg');
        let call = `cscpjs.default.dashboardjs.closeSection('${sectionId}', '${imageId}')`;
        that.utilsjs.changeOnclick(imageId, call);
    }

    showProfile() {
        let that = this;
        let sectionId = 'profileSectionCard';
        that.utilsjs.addClass(sectionId, 'show-on-desktop');
        that.utilsjs.removeClass(sectionId, 'hide-on-desktop');
    }

    hideProfile() {
        let that = this;
        let sectionId = 'profileSectionCard';
        that.utilsjs.addClass(sectionId, 'hide-on-desktop');
        that.utilsjs.removeClass(sectionId, 'show-on-desktop');
    }

    ceuCallback() {
        window.cscpjs.default.utilsjs.loadSafariDatePicker();
        window.cscpjs.default.dashboardTabindexjs.init();
    }

    ceuDateValidate(dateId) {
        let element = document.getElementById(dateId);
        const elementValue = Date.parse(element.value);
        const min = Date.parse(element.min);
        const max = Date.now();
        if (elementValue < min || elementValue > max) {
            return false;
        } else {
            return true;
        }
    }

    async closeCycle(e) {
        console.log('Disabled');

        /*CUSTOM: disabled closecycle API*/
        // e.preventDefault();
        // $(`#submittingCloseCycleButton`).show();
        // $(e.target).attr("disabled", "disabled");
        // if (await this.ajaxjs.postForm("CloseCycle", "Member", "") === '200') {
        //     location.reload();
        // }
    }

    async checkIfCycleIsComplete() {
        // update ItemsRequire count
        $('#ItemsRequire').text($('.required-icon:visible').length);

        /*CUSTOM: Disabled check to show btn closecycle*/
        //var button = $("#close-cycle");
        //var statusText = await this.ajaxjs.postForm("IsRequiredItemsComplete", "Member", "");
        //if (statusText === '200') {
        //    button.removeAttr("disabled");
        //} else {
        //    button.attr("disabled", "disabled");
        //}
    }

    //CUSTOM: Check valid to show Declaration Module
    declarationShowModule() {
        var $module = $('#declaration-section');
        if ($module.length) {
            if (this.declarationCheckShow.Paid === true && this.declarationCheckShow.Guarantor === true && this.declarationCheckShow.CEU === true) {
                $module.removeClass('section-disable');
                $('.declaration-msgvalid-block').removeClass('status-disabled');
            } else {
                $module.addClass('section-disable');
                $('.declaration-msgvalid-block').addClass('status-disabled');
            }
        }
    }

    ceuKeepGetList() {
        var $ceuTable = $('#ceuTable');
        if ($ceuTable.length) {
            var $itemTR = $ceuTable.find('tbody tr');
            var itemCount = $itemTR.length;
            if (itemCount > 0) {
                //console.log('ceuItem: ', itemCount);
                return itemCount;
            }

        }

        return 0;
    }

    convertNumberClean(iNumber) {
        if (iNumber !== '') {
            iNumber = iNumber.replace(',', '.');
            return parseFloat(iNumber);
        }
        return iNumber;
    }

    getEditValueForm(formId) {
        var inputs = document.forms[formId].getElementsByTagName("input");
        var formData = []
        var contentID = ''
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].name == "title" || inputs[i].name == "date" || inputs[i].name == "credits") {
                formData.push({
                    name: inputs[i].name,
                    value: inputs[i].value
                });
            }
            if (inputs[i].name == "contentID") {
                contentID = inputs[i].value
            }
        }
        return { id: contentID, data: formData };
    }
    updateValueCEU(formData, contentId) {
        if (formData && contentId) {
            formData.forEach(function(el){
                if (el) {
                    var col = null;
                    switch (el.name) {
                        case "title":
                            col = document.querySelector('[data-id="'+ contentId +'"] .column-2');
                            if (col && el.value) {
                                col.innerText = el.value
                            }
                            break;
                        case "credits":
                            col = document.querySelector('[data-id="'+ contentId +'"] .column-3');
                            if (col && el.value) {
                                col.innerText = el.value
                            }
                            break;
                        case "date":
                            col = document.querySelector('[data-id="'+ contentId +'"] .column-1');
                            if (col && el.value) {
                                var date = new Date(el.value)
                                col.innerText = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
                            }
                            break;
                        default:
                            break;
                    }
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./Scripts/es6/controllers/dashboard.js